import React from 'react';

function DocumentArtwork() {
  return <>
    <rect width="640" height="320" fill="#DED8C9" />
    <path d="M0 265 640 120V320H0Z" fill="#D0C8B7" />
    <g transform="translate(170 26) rotate(-6 140 140)">
      <rect x="10" y="12" width="294" height="344" rx="4" fill="#B8B09D" opacity=".45" />
      <rect width="294" height="344" rx="4" fill="#FFFDF5" />
      <rect x="29" y="30" width="32" height="5" fill="#63806B" />
      <text x="29" y="58" fill="#65806B" fontSize="10" letterSpacing="2">PLAYER GUIDE / 01</text>
      <text x="29" y="99" fill="#2C4238" fontFamily="Georgia,serif" fontSize="29">Your next</text>
      <text x="29" y="132" fill="#2C4238" fontFamily="Georgia,serif" fontSize="29">adventure.</text>
      <path d="M29 155H261" stroke="#D7DACB" />
      {[181,194,207].map((y,i) => <rect key={y} x="29" y={y} width={i === 2 ? 154 : 229} height="5" rx="2" fill="#D2D8CA" />)}
      <rect x="29" y="232" width="104" height="64" rx="3" fill="#E6EDDF" />
      <text x="42" y="255" fill="#5E795F" fontSize="10">HOW TO PLAY</text>
      <text x="42" y="280" fill="#496A54" fontSize="21">← ↑ ↓ →</text>
      {[239,253,267,281].map((y,i) => <rect key={y} x="151" y={y} width={i === 3 ? 67 : 108} height="5" rx="2" fill="#D2D8CA" />)}
    </g>
    <g transform="translate(432 215) rotate(7)"><rect width="129" height="43" rx="7" fill="#385E49" /><text x="19" y="27" fontSize="14" fill="#F4F5EA">DOCX + PDF</text></g>
  </>;
}
function SpreadsheetArtwork() {
  return <>
    <rect width="640" height="320" fill="#D5E4D0" />
    <circle cx="594" cy="17" r="177" fill="#BED2B8" />
    <rect x="46" y="41" width="548" height="259" rx="7" fill="#F9FBF4" />
    <path d="M53 41H587Q594 41 594 48V80H46V48Q46 41 53 41" fill="#325D44" />
    <text x="65" y="67" fill="#E8F1E0" fontSize="13">Launch budget</text>
    <text x="414" y="66" fill="#B5D1AB" fontSize="11">ƒx  = SUM(D2:D4)</text>
    <g fill="#456B4C" fontSize="12">
      {['ITEM','QTY','RATE','TOTAL'].map((label,i) => <text key={label} x={[66,203,266,333][i]} y="110" fontSize="9" fill="#86A07E">{label}</text>)}
      {[['Art','2','$75','$150'],['Music','1','$120','$120'],['Testing','4','$25','$100']].map((row,i) => <g key={i}><path d={`M62 ${124+i*38}H390`} stroke="#DCE6D5" />{row.map((label,j) => <text key={j} x={[66,203,266,333][j]} y={148+i*38}>{label}</text>)}</g>)}
      <rect x="192" y="199" width="49" height="35" fill="#87B279" fillOpacity=".15" stroke="#729D64" strokeWidth="2" />
      <rect x="62" y="248" width="328" height="30" rx="3" fill="#E4EDDC" />
      <text x="73" y="268">Grand total</text><text x="329" y="268" fontWeight="700">$370</text>
    </g>
    <g transform="translate(417 105)">
      <text y="7" fill="#79956D" fontSize="9" letterSpacing="1">BY CATEGORY</text>
      <path d="M0 118H148" stroke="#C3D3B8" />
      {[['Art',96],['Music',77],['Test',64]].map(([label,height],i) => <g key={label}><rect x={10+i*47} y={118-height} width="28" height={height} rx="3" fill={['#466E49','#85A376','#B5C7A0'][i]} /><text x={12+i*47} y="137" fontSize="9" fill="#718567">{label}</text></g>)}
    </g>
  </>;
}
function PresentationArtwork() {
  return <>
    <rect width="640" height="320" fill="#D9D4E5" />
    <rect x="32" y="32" width="576" height="263" rx="8" fill="#F0EDF5" />
    <rect x="47" y="48" width="76" height="48" rx="4" fill="#D6CBDF" stroke="#86769B" strokeWidth="2" />
    <rect x="57" y="60" width="31" height="4" rx="2" fill="#8D7A9A" /><rect x="57" y="70" width="48" height="3" rx="1" fill="#B5A5C1" />
    <rect x="47" y="107" width="76" height="48" rx="4" fill="#E1DBE9" /><circle cx="84" cy="131" r="13" fill="#B3A5C6" />
    <rect x="47" y="166" width="76" height="48" rx="4" fill="#E1DBE9" />
    {[13,23,32].map((h,i) => <rect key={h} x={59+i*17} y={204-h} width="11" height={h} fill="#B3A5C6" />)}
    <rect x="139" y="48" width="453" height="230" rx="4" fill="#4C3E60" />
    <circle cx="513" cy="162" r="71" fill="#BDA9C8" />
    <circle cx="513" cy="162" r="39" fill="#4C3E60" />
    <path d="M481 120 557 192" stroke="#E7C093" strokeWidth="22" />
    <text x="164" y="83" fill="#D2C5DD" fontSize="9" letterSpacing="2">THE PITCH / 01</text>
    <text x="164" y="133" fill="#FAF4E7" fontFamily="Georgia,serif" fontSize="32">A small game.</text>
    <text x="164" y="169" fill="#FAF4E7" fontFamily="Georgia,serif" fontSize="32">A big adventure.</text>
    <rect x="164" y="201" width="149" height="4" rx="2" fill="#A598B3" />
    <rect x="164" y="213" width="115" height="4" rx="2" fill="#A598B3" />
    <text x="164" y="258" fill="#B8A9C9" fontSize="9">STAR COLLECTOR</text>
  </>;
}
function ImageArtwork() {
  return <>
    <rect width="640" height="320" fill="#E8C7BA" />
    <path d="M0 259 640 170V320H0Z" fill="#D9B4A8" />
    <rect x="126" y="23" width="388" height="275" rx="5" fill="#F6DEBC" />
    <circle cx="378" cy="97" r="49" fill="#D88761" />
    <path d="M126 214 245 90 382 258H126Z" fill="#B87866" /><path d="m226 258 175-147 113 144v43H126v-40Z" fill="#795F67" />
    <path d="M126 279Q239 201 375 266T514 238V298H126Z" fill="#484F59" />
    <rect x="311" y="33" width="133" height="133" fill="#FFFFFF" fillOpacity=".08" stroke="#FFF6DC" strokeWidth="2" strokeDasharray="6 5" />
    {[[126,23],[514,23],[126,298],[514,298]].map(([x,y]) => <rect key={`${x}-${y}`} x={x-4} y={y-4} width="8" height="8" fill="#FFF9E8" stroke="#A57968" />)}
    <g transform="translate(420 185)"><rect width="169" height="53" rx="8" fill="#FFFAEE" /><circle cx="22" cy="26" r="10" fill="#DBE2C9" /><path d="m17 26 4 4 7-8" stroke="#577056" strokeWidth="2" fill="none" /><text x="41" y="24" fill="#5C5B4C" fontSize="11">Select a region</text><text x="41" y="40" fill="#968573" fontSize="9">Describe your edit</text></g>
  </>;
}
function VideoArtwork() {
  return <>
    <rect width="640" height="320" fill="#243B45" />
    <rect x="170" y="21" width="300" height="172" rx="5" fill="#DAC9A0" />
    <circle cx="373" cy="73" r="29" fill="#BC7659" />
    <path d="m170 170 91-101 72 84 78-55 59 72v23H170Z" fill="#719080" /><path d="M170 174Q245 130 321 176T470 149V193H170Z" fill="#42675E" />
    <circle cx="320" cy="105" r="25" fill="#FAF7E5" fillOpacity=".85" /><path d="m314 94 17 11-17 11Z" fill="#426158" />
    <text x="493" y="176" fill="#AEC1C3" fontSize="11">00:15</text>
    <path d="M39 214H602" stroke="#46616A" />
    {[['00s',44],['05s',230],['10s',416]].map(([label,x],i) => <g key={label}><text x={x} y="230" fill="#8CA8AD" fontSize="9">{label}</text><rect x={x} y="240" width="175" height="30" rx="4" fill={['#8EA997','#A9B78C','#C0AE83'][i]} />{[0,1,2,3].map(j => <path key={j} d={`m${x+12+j*42} 263 13-17 18 17Z`} fill="#3B655E" fillOpacity=".32" />)}</g>)}
    <rect x="44" y="279" width="547" height="17" rx="3" fill="#3E6D66" />
    {Array.from({length:63},(_,i) => <path key={i} d={`M${52+i*8.4} ${287-(i%5+1)}v${(i%5+1)*2}`} stroke="#98B5A5" strokeWidth="2" />)}
    <path d="M282 209V303" stroke="#ECD7A6" strokeWidth="2" /><path d="m277 207 5 6 5-6Z" fill="#ECD7A6" />
  </>;
}
function GameArtwork() {
  return <>
    <rect width="640" height="320" fill="#152F32" />
    {Array.from({length:17},(_,i) => <path key={i} d={`M${i*40} 0V320`} stroke="#244346" strokeWidth="1" />)}
    {Array.from({length:9},(_,i) => <path key={i} d={`M0 ${i*40}H640`} stroke="#244346" strokeWidth="1" />)}
    <text x="28" y="39" fill="#C0D2B3" fontSize="13" fontFamily="monospace" letterSpacing="2">STAR COLLECTOR</text>
    <text x="492" y="39" fill="#DACA87" fontSize="12" fontFamily="monospace">★ 03 / 10</text>
    {[[40,110,160],[240,70,120],[360,150,200],[80,250,200],[440,270,160]].map(([x,y,w]) => <g key={x}><rect x={x} y={y} width={w} height="22" fill="#416C65" /><rect x={x} y={y} width={w} height="5" fill="#7BA38A" />{Array.from({length:w/20},(_,i) => <path key={i} d={`M${x+i*20} ${y+6}v16`} stroke="#2D5553" />)}</g>)}
    <g transform="translate(294 192)"><rect x="-11" y="-26" width="23" height="22" fill="#E7D9A7" /><rect x="-15" y="-6" width="31" height="26" fill="#8EBEA3" /><rect x="-12" y="20" width="9" height="13" fill="#C7DAC0" /><rect x="7" y="20" width="9" height="13" fill="#C7DAC0" /><rect x="3" y="-19" width="5" height="5" fill="#254745" /></g>
    {[[118,75],[298,38],[444,111],[525,222]].map(([x,y]) => <path key={x} d="m0-12 4 8 9 1-7 7 2 9-8-4-8 4 2-9-7-7 9-1Z" transform={`translate(${x} ${y})`} fill="#DDBB67" />)}
    <path d="M317 176Q354 101 402 113" stroke="#85ADA0" strokeWidth="2" strokeDasharray="5 7" fill="none" />
    <g transform="translate(29 281)" fill="#31534F" stroke="#6C9081">{[0,1,2,3].map(i => <rect key={i} x={i*28} width="23" height="23" rx="3" />)}</g>
    <text x="35" y="298" fill="#B1C9B0" fontSize="13" letterSpacing="14">←↑↓→</text>
  </>;
}
const ARTWORK = {
  'work-documents': DocumentArtwork,
  'work-spreadsheets': SpreadsheetArtwork,
  'work-presentations': PresentationArtwork,
  'work-images': ImageArtwork,
  'work-videos': VideoArtwork,
  'work-games': GameArtwork,
  'work-video-editor': VideoArtwork,
  'work-image-editor': ImageArtwork,
};

export default function WorkshopArtwork({ slug }) {
  const Artwork = ARTWORK[slug];
  if (!Artwork) return null;
  return <div aria-hidden="true" style={{ aspectRatio: '2 / 1', overflow: 'hidden', borderRadius: 6, marginBottom: 20 }}>
    <svg viewBox="0 0 640 320" width="100%" height="100%" focusable="false" style={{ display: 'block', fontFamily: 'system-ui, sans-serif' }}><Artwork /></svg>
  </div>;
}
